import getWithXHR from 'Common/utils/getWithXHR'

const url = '/api/v1/flashcard_genres'

const getGenres = () => getWithXHR(url)

export default getGenres
